<style scoped>
  .avatar {
    width: 110px;
    /* border-radius: 115px; */
    border-radius: 20px;
    height: 110px;
    top: 0px !important;
  }

  .profile-holder{
    margin: 0 !important;
  }

  .profile-header > .profile-info {
    display: inline-block;
    position: absolute;
    margin-left: 140px;
    overflow-y: hidden;
    max-height: 112px;
  }

  .update-profile-image{
    position: absolute;
    top: -8px;
    left: 95px;
    background: #000000ba;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .update-profile-image > i {
    font-size: 1.4em;
    color: #fff;
  }

  .save-profile{
    position: fixed;
    bottom: 0;
    width: 100%;
    z-index: 9;
    background: #fff;
    /* padding: 5px; */
    border-top: 1px solid #ddd;
  }
</style>
<style>
.profile-settings .profile-holder .profile-header .display-name .ivu-input-large {
    font-size: 1.17em;
    font-weight: bold;
  }
</style>


<template>
  <AppLayout class="profile-settings">
    <Row type="flex" justify="center">
      <i-col :span="24">
        <Card class="profile-holder" shadow :padding="15" :style="{borderRadius: '0'}" style="margin:15px">
          <div style="position:relative;height: 116px;" v-if="profileInfo" class="profile-header">
            <img v-on:click="uploadImage" class="avatar" :src="newImage || userDisplayImage(profileInfo)" width="100%" alt="IMAGE"/>
            <div class="update-profile-image" v-on:click="uploadImage">
              <Icon type="camera"></Icon>
            </div>
            <div class="profile-info" >
              <i-input size="large" class="display-name" v-model="displayName" @on-change="displayNameChange"></i-input>
            </div>
          </div>
          <span style="position:absolute;right:25px;bottom:15px">
            <!-- <Poptip title="Checkboxes" width="150" placement="top-end">
            <div slot="content" style="word-wrap: break-word;white-space: normal;text-align: left;">Check if you want to display field on about tab of your profile</div>
            <Checkbox disabled :value="true"/> <small style="color:#aaa">Display in about me tab</small></Poptip> -->
          </span>
        </Card>
        <UserProfileSettingComponent  @hasChanges="changeProfile" ref="profileComponentNew"></UserProfileSettingComponent>
        <!-- <ProfileInfoComponent ref="profileComponent" @onSaveData="madeChanges"></ProfileInfoComponent> -->
        <div class="save-profile">
          <!-- <Button type="primary" :disabled="!hasChanges" long v-on:click="saveProfile" style="border-radius: 0;">Save</Button> -->
        </div>
      </i-col>
    </Row>
  </AppLayout>
</template>

<script>
  import ProfileInfoComponent from "@/components/ProfileInfoComponent";
  import UserProfileSettingComponent from '@/views/UserProfileSettingComponent'
  import Utils from '@/utils.js'

  export default {
    name: 'ProfileSettings',
    components: {
      UserProfileSettingComponent,
      ProfileInfoComponent
    },
    beforeCreate() {
      this.$store.dispatch('user/getUserFields')
    },
    created() {
      BroadcastEvent.$on('ONNEWIMAGECHANGE', (v) => {
        this.newImage = null
        this.newImage = v
      })
      BroadcastEvent.$on('ONNEWIMAGECHANGEGALLERY', (v) => {
        this.profileInfo.avatar = v
      })
    },
    data() {
      return {
        newImage: null,
        hasChanges: false,
        emptyDisplayName: false,
        displayName: ''
      }
    },
    beforeRouteLeave (to, from, next) {
      if(this.hasChanges && to.params.brandSlug){

        // this.$Modal.confirm({
        //   title: 'Save changes',
        //   content: '<p>Do you want to save your changes?</p>',
        //   okText: 'Yes',
        //   cancelText: 'Cancel',
        //   onOk: () => {
        //     this.saveProfile();
        //     next();
        //   },
        //   onCancel: () => {
        //     next();
        //   }
        // });
        this.$Message({
          closable: true,
          title: { content:'Save changes' },
          icon: 'help',
          message: { content: 'Do you want to save your changes?' },
          buttons: [
            { label: 'No', type: 'default', hideAfter:true, action: ()=> next() },
            { label: 'Yes', type: 'primary', hideAfter:true, action: ()=> { this.saveProfileChanges(); next() } }
          ]
        });

      }else{
        next();
      }
    },
    computed: {
      userStory() {
        return this.$store.state.library.userStory;
      },
      profileInfo: {
        get () {
          return this.$store.state.user.info
        }
      },
      displayNameRef: {
        get() {
          if (this.$refs.profileComponentNew.profile.display_name == "No Displayname" || this.$refs.profileComponentNew.profile.display_name == this.profileInfo.user_login) {
            return ""
          }
          else {
            return this.$refs.profileComponentNew.profile.display_name
          }
        },
        set(v) {
          this.$refs.profileComponentNew.profile.display_name = v
        }
      },
      updateLoader() {
        return this.$store.state.user.isLoadingUserProfile;
      },
    },
    destroyed() {
      BroadcastEvent.$off('ONNEWIMAGECHANGE')
      BroadcastEvent.$off('ONNEWIMAGECHANGEGALLERY')
      BroadcastEvent.$off('ONSETAVATARIMAGECHANGE')
      BroadcastEvent.$off('ONGALLLERYFIELDCHANGE')
      BroadcastEvent.$off('ONFIELDCHANGE')
    },
    mounted() {
      this.displayName = this.profileInfo.display_name
    },
    methods: {
      uploadImage() {
        this.$refs.profileComponentNew.uploadImage();
        // console.log(this.$refs.profileComponent.uploadImage)
        // this.$refs.uploadImage.triggerUpload();
      },
      saveProfile(data) {
        console.log(this.emptyDisplayName)
        // console.log(data)
        // this.$refs.profileComponent.updateUserInfo();
        // this.hasChanges = false
        if(this.emptyDisplayName){
          this.$Modal.warning({
            title: 'Empty display name',
            content: 'Display name should not be empty.',
            onOk: () => {
              this.profileInfo.display_name = `${this.profileInfo.first_name}  ${this.profileInfo.last_name}`
              this.emptyDisplayName = false
            }
          });
        }else{
          this.$refs.profileComponent.updateUserInfo();
          this.hasChanges = false
        }
      },
      madeChanges(data) {
        // console.log(data)
        this.hasChanges = true
        if(data.slug == 'display_name'){
          this.profileInfo.display_name = data.value
        }

        if(data.slug == 'display_name'){asdasdasdasd
          if(data.value == ''){
            this.emptyDisplayName = true
          }else{
            this.emptyDisplayName = false
          }
        }
      },
      userDisplayImage(user) {
        if( !Utils.validUrl(user.avatar) )
          return process.env.VUE_APP_TEMP + user.avatar;
        return Utils.getDisplayImage('user', user, 'medium')
      },
      changeProfile(value){
        this.hasChanges = value
      },
      saveProfileChanges(){
        this.$refs.profileComponentNew.onSave();
      },
      displayNameChange(data) {;
        // if (this.displayNameRef != this.displayName) this.changeProfile(true) 
        // console.log(this.hasChanges);
        
        this.displayNameRef = this.displayName
        BroadcastEvent.$emit('ONFIELDCHANGE', 'display_name')
      }
    }
  }
</script>
